import type * as React from 'react';
import { useTranslation } from 'next-i18next';
import { Spinner } from '@dx-ui/osc-spinner';

const InlineLoader: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center py-4" role="alert">
      <span className="sr-only">{t('textContent.pleaseWait')}</span>
      <Spinner size="lg" aria-hidden="true" />
    </div>
  );
};

export default InlineLoader;
